export default [
    {
        path: '/consultants/main',
        name: 'consultants/main',
        component: () => import(/* webpackChunkName: "consultants" */ '../views/consultants/main')
    },
    {
        path: '/consultants/filter/main',
        name: 'consultants/filter/main',
        component: () => import(/* webpackChunkName: "consultants" */ '../views/consultants/filter/main')
    },
    {
        path: '/consultants/card/main',
        name: 'consultants/card/main',
        component: () => import(/* webpackChunkName: "consultants" */ '../views/consultants/card/main')
    },
    {
        path: '/consultants/card/wx_card/main',
        name: 'consultants/card/wx_card/main',
        component: () => import(/* webpackChunkName: "consultants" */ '../views/consultants/card/wx_card/main')
    },
    {
        path: '/consultants/feeds/search',
        name: 'consultants/feeds/search',
        component: () => import(/* webpackChunkName: "consultants" */ '../views/consultants/feeds/search')
    },
]